import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Modal, Table, Card, Button} from 'semantic-ui-react';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';

class OnOrderModal extends Component {
  constructor(props) {
    super(props);
    this.handleAcceptClick = this.handleAcceptClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {partCode, showModal} = this.props;
    const isOpen = !prevProps.showModal && showModal;

    if (isOpen && partCode && prevProps.partCode !== partCode) {
      this.props.fetchOnOrdersDetail(partCode, true);
    }
  }

  handleAcceptClick() {
    this.props.hideOrderPartOnOrder();
  }

  renderDetail() {
    const {loading, onOrdersDetail} = this.props;

    if (loading) {
      return (
        <Card fluid>
          Consultando información...
        </Card>
      );
    }

    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Fecha Pedido</Table.HeaderCell>
            <Table.HeaderCell>Fecha ETA</Table.HeaderCell>
            <Table.HeaderCell>Fecha Arribo</Table.HeaderCell>
            <Table.HeaderCell>N. Pedido</Table.HeaderCell>
            <Table.HeaderCell>C. Solicitada</Table.HeaderCell>
            <Table.HeaderCell>N. Factura</Table.HeaderCell>
            <Table.HeaderCell>C. Atendida</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.renderTableBody(onOrdersDetail)}
        </Table.Body>
      </Table>
    );
  }

  renderTableBody(detail) {
    if (!detail.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='6' textAlign='center'>
            No se encontraron registros.
          </Table.Cell>
        </Table.Row>
      );
    }

    return detail.map((onOrder, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>
            {this.renderDateField(onOrder.processDate)}
          </Table.Cell>
          <Table.Cell>
            {this.renderDateField(onOrder.arriveDate)}
          </Table.Cell>
          <Table.Cell>
            {this.renderArrivalDates(onOrder.arrivalDate)}
          </Table.Cell>
          <Table.Cell>{onOrder.orderCode}</Table.Cell>
          <Table.Cell textAlign='right'>{onOrder.quantity}</Table.Cell>
          <Table.Cell>{onOrder.invoice}</Table.Cell>
          <Table.Cell textAlign='right'>{onOrder.attendedQuantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderArrivalDates(value = []) {
    const parsedDates = value.map((date) => this.renderDateField(date));

    return parsedDates.join(' / ');
  }

  renderDateField(value) {
    if (!value) {
      return null;
    }

    return moment(value).format(reverseShortDate);
  }

  render() {
    const {partCode, showModal} = this.props;

    return (
      <Modal
        size='large'
        className='stock-modal'
        trigger={<div />}
        open={showModal}
        onClose={this.handleAcceptClick}
      >
        <Modal.Header>
          On Order - {partCode}
        </Modal.Header>
        <Modal.Content>
          {this.renderDetail()}
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.handleAcceptClick}>ACEPTAR</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'partCode': state.providerStockOrders.partCodeForStock,
    'showModal': state.providerStockOrders.showOnOrderModal,
    'loading': state.partModals.loadingOnOrdersDetail,
    'onOrdersDetail': state.partModals.onOrdersDetail || [],
  };
};

const {
  fetchOnOrdersDetail,
  hideOrderPartOnOrder,
} = Actions;

export default connect(mapStateToProps, {
  fetchOnOrdersDetail,
  hideOrderPartOnOrder,
})(OnOrderModal);
